import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchPlans } from './api';
import {
  FETCH_PLANS,
} from './types';

export const fetchPlansAction = createAsyncThunk(
  FETCH_PLANS,
  () => fetchPlans(),
);
